import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface LicitacaoItem {
  numero: number | null;
  descricao: string | null;
  quantidade: number | null;
  unidade: string | null;
  valor_unitario: number | null;
  valor_total: number | null;
  criterio: string | null;
  situacao: string | null;
  material_servico: string | null;
  catalogo_codigo: string | null;
}

export interface LicitacaoArquivo {
  titulo: string | null;
  url: string | null;
  tipo: string | null;
  data_publicacao: string | null;
  sequencial: number | null;
}

export interface LicitacaoHistoricoEvento {
  data: string | null;
  tipo: string | null;
  categoria: string | null;
  documento_tipo: string | null;
  documento_titulo: string | null;
  responsavel: string | null;
}

/** Portal de origem para onde mandar o usuário quando não há detalhe PNCP automático. */
export interface FonteExterna {
  url: string;
  rotulo: string;
}

/** Envelope comum: degradação graciosa quando a origem recusa ou não há controle PNCP. */
interface PncpRecursoBase {
  origem_recusou: boolean;
  indisponivel: boolean;
  motivo?: string;
  fonte_externa?: FonteExterna | null;
}

export interface LicitacaoItensData extends PncpRecursoBase { itens: LicitacaoItem[] }
export interface LicitacaoArquivosData extends PncpRecursoBase { arquivos: LicitacaoArquivo[] }
export interface LicitacaoHistoricoData extends PncpRecursoBase { historico: LicitacaoHistoricoEvento[] }

interface Envelope<T> { success: boolean; data: T }

function usePncpRecurso<T>(recurso: string, licitacaoId: number | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['licitacao-pncp', recurso, licitacaoId],
    enabled: Boolean(licitacaoId) && enabled,
    staleTime: 15 * 60 * 1000, // alinhado ao cache do backend
    queryFn: async () => {
      const envelope = await api.get<Envelope<T>>(`/licitacoes/${licitacaoId}/${recurso}`);
      return envelope.data;
    },
  });
}

export const useLicitacaoItens = (licitacaoId: number | undefined, enabled: boolean) =>
  usePncpRecurso<LicitacaoItensData>('itens', licitacaoId, enabled);

export const useLicitacaoArquivos = (licitacaoId: number | undefined, enabled: boolean) =>
  usePncpRecurso<LicitacaoArquivosData>('arquivos', licitacaoId, enabled);

export const useLicitacaoHistorico = (licitacaoId: number | undefined, enabled: boolean) =>
  usePncpRecurso<LicitacaoHistoricoData>('historico', licitacaoId, enabled);
